import { AfterViewInit, Component, ElementRef, Input, NgZone, OnDestroy, ViewChild, inject, DOCUMENT } from '@angular/core';
import { BannerModel } from '@shared/models';

import { WindowService } from '@shared/window';
import Swiper from 'swiper';
import { Subscription } from 'rxjs';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import { SlideComponent } from './components/slide/slide.component';

@Component({
    selector: 'app-main-slider',
    templateUrl: './main-slider.component.html',
    styleUrls: ['./main-slider.component.scss'],
    imports: [SlideComponent],
})
export class MainSliderComponent implements AfterViewInit, OnDestroy {
    public zone = inject(NgZone);
    public document = inject(DOCUMENT);
    windowService = inject(WindowService);

    @Input({ required: true }) banners!: BannerModel[];
    @Input() fullwidth = true;
    @ViewChild('swiper') swiperRef!: ElementRef<HTMLDivElement>;
    @ViewChild('swiperPagination') swiperPaginationRef!: ElementRef<HTMLDivElement>;
    @ViewChild('swiperNavigationNext') swiperNavigationNextRef!: ElementRef<HTMLDivElement>;
    @ViewChild('swiperNavigationPrev') swiperNavigationPrevRef!: ElementRef<HTMLDivElement>;

    readonly isClient = this.windowService.isClient;

    private swiper?: Swiper;
    private subscriptions$ = new Subscription();

    ngAfterViewInit() {
        if (this.windowService.isBrowser) {
            this.initSwiper();
        }
    }

    ngOnDestroy(): void {
        this.swiper?.destroy();
        this.subscriptions$.unsubscribe();
    }

    private initSwiper() {
        this.zone.runOutsideAngular(() => {
            this.swiper = new Swiper(this.swiperRef.nativeElement, {
                modules: [Pagination, Navigation, Autoplay],
                slidesPerView: 1,
                pagination: {
                    el: this.swiperPaginationRef.nativeElement,
                    type: 'bullets',
                },
                navigation: {
                    nextEl: this.swiperNavigationNextRef.nativeElement,
                    prevEl: this.swiperNavigationPrevRef.nativeElement,
                },
                speed: 2000,
                observer: true,
                updateOnWindowResize: true,
                resizeObserver: true,
                watchOverflow: true,
                observeParents: true,
                observeSlideChildren: true,
                autoplay: {
                    delay: 3000,
                    stopOnLastSlide: false,
                    disableOnInteraction: false,
                    waitForTransition: true,
                },
                autoHeight: true,
                loop: true,
                noSwipingSelector: 'app-button',
            });
        });
    }
}
